import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const Editmemberteam = () => {
    const [name, setName] = useState('');
    let { id } = useParams();
 //   const [id, setId] = useState(0);
    let navigt = useNavigate();


    const  formSubmit = (e)=>{
            e.preventDefault()
            axios.post(`https://backend.dasta.net/api/auth/updatenewteam/${id}`,{
                name,
            }).then((data)=>{
                navigt(-1);
            })
        }  
    return(
        
        <>
            <form onSubmit={formSubmit}>
                <label for="fname" >Edit The Name :</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setName(e.target.value)}/>
                <button type='submit' >add</button>
             </form> 
        </>
        
    )
}
export default Editmemberteam;